import React, { FC } from 'react'
import { IconS24DocumentCoinStack48 } from '@is24/cosma-ui-icons'

export const SolarIntentStepIcon: FC = () => (
  <div className='icon-container'>
    <IconS24DocumentCoinStack48 width={128} height={128} />
  </div>
)
